import { FC, useMemo } from 'react'
import { Col } from 'react-bootstrap'
import Loader from 'components/ui/loader/Loader'

import {
  getProgressDefault,
  getProgressPercentage,
} from 'components/monitoring/utils'

import { AreaProgress as IAreaProgress } from 'graphqlAPI'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from '../Tabs/Areas/constants'
import { Cards } from './Cards'

interface GeneralProgressProps {
  data?: {
    coursesProgress: IAreaProgress[]
    participantsCount: number
    coursesCount: number
  }
  loading: boolean
}

export const GeneralProgress: FC<GeneralProgressProps> = ({
  data,
  loading,
}) => {
  const { coursesProgress } = { ...data }

  const participants = useMemo(
    () => getProgressPercentage(coursesProgress || []),
    [coursesProgress]
  )
  const tRelative = useTranslationRankmi({ prefix })

  const courses = useMemo(
    () =>
      (coursesProgress || []).reduce((acc, val) => {
        if (val.pending > 0) {
          acc.pending += 1
          return acc
        }
        if (val.inProgress > 0) {
          acc.inProgress += 1
          return acc
        }
        acc.finish += 1
        return acc
      }, getProgressDefault()),
    [coursesProgress]
  )

  if (loading) {
    return (
      <Col>
        <div className="d-flex justify-content-center">
          <Loader color />
        </div>
      </Col>
    )
  }
  if (!data) return null

  const { coursesCount, participantsCount } = data

  return (
    <>
      <Col md={12} lg={6}>
        <Cards
          title={tRelative('cards.courses')}
          total={coursesCount}
          className="mt-6"
          finish={courses.finish}
          inProgress={courses.inProgress}
          pending={courses.pending}
        />
      </Col>
      <Col md={12} lg={6}>
        <Cards
          title={tRelative('cards.participants')}
          total={participantsCount}
          className="mt-6"
          finish={participants.finish}
          inProgress={participants.inProgress}
          pending={participants.pending}
        />
      </Col>
    </>
  )
}
